// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"styles_carouselContainer__XRa3h","leftAlign":"styles_leftAlign__mC_9y","centerAlign":"styles_centerAlign__YBKr5"};